import { useJourneysEdit } from "@ryde/redux";
import {
  createRydeColumnHelper,
  IColumnDef,
  IRideDto,
  NO_VALUE_DISPLAY,
  useIsMobile,
} from "@ryde/shared";

import { CourseIndicatorRides } from "../../../../grid/cell-templates/rides/summary/course.indicator.rides";
import { EditLinkStyled } from "../../../../grid/generic/cells/cell-link.styled";
import { GenericSortableCell } from "../../../../grid/generic/cells/cell.generic.sortable";
import { CellNotOverflowedStyled } from "../../../../grid/generic/cells/cell.styled";
import { idEmptyColumnObj } from "../../../../grid/generic/table/table-defs/table-def.columns.fixed";
import { CurrencyCellTemplate } from "../../../templates-table/currency-cell.template";
import { DateEditableTemplate } from "../../../templates-table/date-editable.template";
import { RideStatusCellTemplate } from "../../../templates-table/ride-status-cell.template";
import { TextCellTemplate } from "../../../templates-table/text-cell.template";

const columnHelper = createRydeColumnHelper<IRideDto>();

export const useTableDefsRidesNestedGrid = () => {
  const { isMobile } = useIsMobile();

  const { onEditRideJourneyClick } = useJourneysEdit();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const RidesNestedGridTableDefs: IColumnDef<IRideDto, any>[] = [
    columnHelper.display(idEmptyColumnObj()),

    {
      id: "course_icon_wrapper",
      header: () => "",
      cell: ({ row }) => {
        return (
          <>
            {!isMobile && !!row?.original?.courseId && (
              <span className="course_icon_wrapper">
                <CourseIndicatorRides rideDto={row?.original} />
              </span>
            )}
          </>
        );
      },
      meta: {
        columnWidth: 30,
      },
    },

    {
      id: "id",
      header: () => "#",
      cell: ({ row }) => (
        <CellNotOverflowedStyled
          onClick={() => onEditRideJourneyClick(+row?.id)}
        >
          <EditLinkStyled>{row.id}</EditLinkStyled>
        </CellNotOverflowedStyled>
      ),
      meta: {
        fixed: true,
      },
    },
    {
      id: "status",
      header: () => (
        <GenericSortableCell
          fieldNameResolved="status"
          translationKey="ride.gridLabel.status"
        />
      ),
      cell: ({ row }) => (
        <RideStatusCellTemplate name="status" value={row?.original?.status} />
      ),
      meta: {
        fixed: true,
        columnWidth: 100,
      },
    },
    {
      id: "supplierId",
      header: () => (
        <GenericSortableCell
          fieldNameResolved="supplierId"
          translationKey="ride.gridLabel.supplierId"
        />
      ),
      cell: ({ row }) => (
        <TextCellTemplate
          name="supplierId"
          value={row?.original?.supplierName ?? NO_VALUE_DISPLAY}
        />
      ),
      meta: {
        fixed: true,
        columnWidth: 100,
      },
    },
    {
      id: "vehicleTypeId",
      header: () => (
        <GenericSortableCell
          fieldNameResolved="vehicleTypeId"
          translationKey="ride.gridLabel.vehicleTypeId"
        />
      ),
      cell: ({ row }) => (
        <TextCellTemplate
          name="vehicleTypeId"
          value={row?.original?.vehicleTypeName ?? NO_VALUE_DISPLAY}
        />
      ),
      meta: {
        fixed: true,
        columnWidth: 100,
      },
    },
    {
      id: "originStationId",
      header: () => (
        <GenericSortableCell
          fieldNameResolved="originStationId"
          translationKey="ride.gridLabel.originStationId"
        />
      ),
      cell: ({ row }) => (
        <TextCellTemplate
          name="originStationId"
          value={row?.original?.originStationName}
        />
      ),
      meta: {
        fixed: true,
        columnWidth: 100,
      },
    },
    {
      id: "destinationStationId",
      header: () => (
        <GenericSortableCell
          fieldNameResolved="destinationStationId"
          translationKey="ride.gridLabel.destinationStationId"
        />
      ),
      cell: ({ row }) => (
        <TextCellTemplate
          name="destinationStationId"
          value={row?.original?.destinationStationName}
        />
      ),
      meta: {
        fixed: true,
        columnWidth: 100,
      },
    },
    {
      id: "rideStart",
      header: () => (
        <GenericSortableCell
          fieldNameResolved="rideStart"
          translationKey="ride.gridLabel.rideStart"
        />
      ),
      cell: ({ row }) => (
        <DateEditableTemplate
          name="rideStart"
          value={row?.original?.rideStart}
          rowId={row.original.id}
        />
      ),
      meta: {
        fixed: true,
        columnWidth: 150,
      },
    },
    {
      id: "rideEnd",
      header: () => (
        <GenericSortableCell
          fieldNameResolved="rideEnd"
          translationKey="ride.gridLabel.rideEnd"
        />
      ),
      cell: ({ row }) => (
        <DateEditableTemplate
          name="rideEnd"
          value={row?.original?.rideEnd}
          rowId={row.original?.id}
        />
      ),
      meta: {
        fixed: true,
        columnWidth: 150,
      },
    },
    {
      id: "price",
      header: () => (
        <GenericSortableCell
          fieldNameResolved="price"
          translationKey="ride.gridLabel.price"
        />
      ),
      cell: ({ row }) => (
        <CurrencyCellTemplate value={row?.original?.price} name="price" />
      ),
      meta: {
        fixed: true,
        columnWidth: 50,
      },
    },
  ];

  return { RidesNestedGridTableDefs };
};
